// src/components/SignatureField.js

import React, { forwardRef } from "react";
import SignatureCanvas from "react-signature-canvas";

const SignatureField = forwardRef((props, ref) => {
  return (
    <SignatureCanvas
      ref={ref}

      /* 🔒 DO NOT CHANGE THESE */
      penColor="#000000"          // always black ink
      backgroundColor="#ffffff"  // always white background

      canvasProps={{
        width: 500,
        height: 200,
        style: {
          width: "100%",
          height: 200,
          backgroundColor: "#ffffff",
          border: "1px solid #000",
          borderRadius: "6px",
          display: "block",
        },
      }}

      {...props}
    />
  );
});

export default SignatureField;
